import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultCrisisMangeGuidelines = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultCrisisMangeGuidelines' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> CRISIS MANAGEMENT GUIDELINES  </center> </b>
                </p>
                <p className='w-750'>

                    <ol>
                        <li>It is the policy of Jackson Hands of Change to provide a safe setting for the persons served and personnel.</li>
                        <li>This agency strictly prohibits the use of seclusion or restraints.</li>
                        <li>All personnel who provide direct services are training in Crisis Management Intervention (CPI) and/or Prevention and Management of Aggressive Behaviors (PMAB).</li>
                        <li>All persons served participate in the development of their own crisis plan at the onset of treatment and on an ongoing basis.</li>
                        <li>
                            Each consumer is given a copy of their crisis plan, which will be initiated  at the onset of a crisis.
                            <ol type='a'>
                                <li>What constitutes a crisis, as well as the actions to be taken, will be identified on the individualized crisis plan.</li>
                                <li>The goal of the plan is to foster individual and family strengths and to prevent the need for admission to higher levels of care, or to prevent removal from the home.</li>
                            </ol>

                        </li>
                        <li>
                            Provision of 24 hour services:
                            <ol type='a'>
                                <li>All persons served have 24 access to emergency evaluations and brief intervention services that include direct contact and/or consultation with the psychiatrist.</li>
                                <li>All crisis situations are assessed by a licensed Mental Health Professional (LMHP) via face to face evaluation and/or by telephone, as needed for medication management and/or consultation.</li>
                                <li>After hours persons served are able to access emergency services by calling the office answering service at 504-342-1011.   The staff on call must contact the family and or person served within 1520 minutes of the call. The psychiatrist is contacted the LMHP as needed after hours, for medication management or consultation.</li>
                            </ol>
                        </li>
                        <li>The LMHP on call will be responsible for keeping the crisis phone  in their possession during the entire on call period.</li>
                        <li>
                            Educating the person served regarding 24 hours services:
                            <ol type='a'>
                                <li>Persons served will educated on how to call for  emergency services at the time of admission. Access to emergency services will be discussed with the persons served while reviewing the client handbook.</li>
                                <li>During admission, person"s served will be given the handbook with a list of number for emergency services.</li>
                            </ol>

                        </li>
                    </ol>
                </p>

                <p className='w-750'>
                    By signing below, I acknowledge that I understand Jackson Hands of change Crisis Management Guidelines.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}